import {
  Button,
  InputNumber,
  Modal,
  Popover,
  Select,
  Space,
  Input,
  Row,
  Table,
} from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BudgetApi } from "../../../../api";
import SubItemTable from "./subItemTable";
const ItemTable = (props) => {
  const { Search } = Input;
  const { projectId, defaultSelectedItems, editId } = props;
  const { Option } = Select;
  const [selectedItems, setSelectedItems] = useState([]);
  const [visible, setVisible] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedRowKeysSub, setSelectedRowKeysSub] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedRowsSub, setSelectedRowsSub] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState(
    props?.selectedRowKeys
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSubs, setSelectedSubs] = useState({});
  const [selectedSubsKeys, setSelectedSubsKeys] = useState([]);
  const [defaultTax, setDefaultTax] = useState(null);
  const taxFinder = (tax) => {
    if (tax) return taxTypes.filter((each) => each.id === tax)[0]?.percentage;
    return 0;
  };
  const taxTypes = [
    {
      id: 1,
      label: "None",
      value: "none",
    },
    {
      id: 2,
      label: "CGST/SGST",
      value: "cgst_sgst",
    },
    {
      id: 4,
      label: "IGST",
      value: "igst",
    },
  ];
  useEffect(() => {
    console.log(props, "props");
    fetchItems();
    if (editId) {
      console.log(props.defaultSelectedItems, "ss");
      setSelectedItems(props.defaultSelectedItems);
    }
  }, []);
  useEffect(() => {
    setSelectedRowKeys(props?.selectedRowKeys);
  }, [props?.selectedRowKeys]);

  useEffect(() => {
    console.log("search", searchText);
  }, [searchText, items]);

  useEffect(() => {
    setSelectedItems(defaultSelectedItems);
    var item = [];
    var itemKeys = [];
    var sub_item = [];
    var sub_itemKeys = [];
    for (let i = 0; i < defaultSelectedItems?.length; i++) {
      if (defaultSelectedItems[i]?.sub_items?.length === 0) {
        item.push(defaultSelectedItems[i]);
        itemKeys.push(defaultSelectedItems[i]?.id);
      } else if (defaultSelectedItems[i]?.boq_sub_item) {
        sub_item.push(defaultSelectedItems[i]);
        sub_itemKeys.push(defaultSelectedItems[i]?.id);
      }
    }
    console.log(sub_item, "sub_item");
    setSelectedRowKeys(itemKeys);
    setSelectedRows(item);
    setSelectedRowsSub(sub_item);
    setSelectedRowKeysSub(sub_itemKeys);
  }, [defaultSelectedItems]);

  const fetchItems = () => {
    axios.get(`${BudgetApi}?project=` + projectId).then((res) => {
      const items = res.data?.map((item) => {
        const children = item?.sub_items?.map((sub_item) => {
          return {
            ...sub_item,
            boq_item: sub_item.boq_sub_item,
            category_name: sub_item?.category_name_id,
          };
        });
        if (children?.length > 0) {
          return {
            ...item,
            children: children,
          };
        }
        return { ...item };
      });
      setItems(items);
    });
  };

  const onChange = (value, data, name) => {
    const arr = selectedItems;
    if (data?.boq_item) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].boq_item && arr[i].id === data.id) {
          arr[i][name] = value;
        }
      }
    } else {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].boq_sub_item && arr[i].id === data.id) {
          arr[i][name] = value;
        }
      }
    }
    console.log(arr, selectedItems, "   ");
    setSelectedItems([...arr]);
    props.setItems([...arr]);
  };
  const columns = [
    {
      title: "BOQ Item",
      key: "boq_item",
      render: (data) => (
        <span>{data?.boq_item ? data?.boq_item : data?.boq_sub_item}</span>
      ),
      fixed: "left",
      width: 150,
    },
    {
      title: "Description",
      key: "item_description",
      ellipsis: {
        showTitle: false,
      },
      render: (data) => (
        <Popover
          placement="topLeft"
          title={"Item Description"}
          content={data?.item_description}
        >
          {data?.item_description}
        </Popover>
      ),
      width: 200,
    },
    {
      title: "Quantity",
      key: "quantity",
      width: 120,
      render: (data) => (
        <InputNumber
          type="number"
          defaultValue={data?.quantity}
          onChange={(e) => {
            onChange(e, data, "quantity");
          }}
        />
      ),
    },
    {
      title: "Unit",
      key: "unit",
      dataIndex: "unit",
      width: 120,
    },
    {
      title: "Make/Brand",
      key: "brand",
      dataIndex: "brand",
      width: 120,
    },
    {
      title: "Price",
      key: "unit_po_price",
      render: (data) => (
        <>
          <InputNumber
            type="number"
            defaultValue={data?.unit_po_price ?? data?.budget_price}
            // max={data?.budget_price}
            // formatter={(value) => `₹${value}`}
            parser={(value) => value.replace("₹", "")}
            onChange={(e) => {
              onChange(e, data, "unit_po_price");
            }}
          />
          <div
            style={
              data?.unit_po_price > data?.budget_price
                ? {
                    color: "red",
                  }
                : {}
            }
          >
            Budget : ₹{data?.budget_price}
          </div>
        </>
      ),
      width: 160,
    },
    {
      title: "Discount",
      key: "discount",
      width: 200,
      render: (data) => (
        <>
          <InputNumber
            min={0}
            max={100}
            value={data?.discount ?? 0}
            formatter={(value) => `${value}%`}
            parser={(value) => value.replace("%", "")}
            onChange={(e) => {
              onChange(e, data, "discount");
            }}
          />
          {/* <span>Budget : {data?.budget_price}</span> */}
        </>
      ),
    },
    {
      title: "Tax",
      key: "tax",
      render: (data) => (
        <Space>
          <Select
            className="w-100"
            onChange={(e) => {
              onChange(e, data, "tax_value");
            }}
            value={
              defaultTax && defaultTax !== "none" ? defaultTax : data?.tax_value
            }
          >
            {[0, 5, 12, 18, 28]?.map((each, index) => (
              <Option key={index} value={each}>
                {each}
              </Option>
            ))}
          </Select>
          <Select
            className="w-100"
            onChange={(e) => {
              onChange(e, data, "tax_type");
            }}
            value={
              defaultTax && defaultTax !== "none" ? defaultTax : data?.tax_type
            }
          >
            {taxTypes?.map((each) => (
              <Option key={each.id} value={each.value}>
                {each.label}
              </Option>
            ))}
          </Select>
          {/* <span>Budget : {data?.budget_price}</span> */}
        </Space>
      ),
      width: 200,
    },
    {
      title: "Amount",
      key: "amount",
      render: (data) => {
        var total = Number(data?.quantity) * Number(data?.unit_po_price ?? 0);
        var discount = data?.discount ?? 0;
        var price = total - total * discount * 0.01;
        var tax = data?.tax_value;
        price += price * 0.01 * tax;
        return <span>₹ {price?.toFixed(2)}</span>;
      },
      width: 200,
    },
  ];
  const columnsModal = [
    {
      title: "BOQ Item",
      key: "boq_item",
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return (
          String(record.boq_item)
            ?.toLowerCase()
            ?.includes(value?.toLowerCase()) ||
          String(record.item_description)
            ?.toLowerCase()
            ?.includes(value?.toLowerCase()) ||
          String(record.brand)?.toLowerCase()?.includes(value?.toLowerCase()) ||
          String(record.unit)?.toLowerCase()?.includes(value?.toLowerCase()) ||
          String(record.brand)?.toLowerCase()?.includes(value?.toLowerCase())
        );
      },
      render: (data) => (
        <span>{data?.boq_item ? data?.boq_item : data?.boq_sub_item}</span>
      ),
      width: 150,
      fixed: "left",
    },
    {
      title: "Description",
      key: "item_description",
      // filteredValue: [searchText],
      // onFilter: (value, record) => {
      //   return String(record.item_description)
      //     ?.toLowerCase()
      //     ?.includes(value?.toLowerCase());
      // },
      ellipsis: {
        showTitle: false,
      },
      render: (data) => (
        <Popover
          placement="topLeft"
          title={"Item Description"}
          content={data?.item_description}
        >
          {data?.item_description}
        </Popover>
      ),
      width: 200,
    },
    {
      title: "Quantity",
      key: "quantity",
      filteredValue: [searchText],
      dataIndex: "quantity",
      width: 120,
    },
    {
      title: "Unit",
      key: "unit",
      dataIndex: "unit",
      width: 120,
    },
    {
      title: "Make/Brand",
      key: "brand",
      dataIndex: "brand",
      width: 120,
    },
    {
      title: "Price",
      key: "boq_price",
      dataIndex: "boq_price",
      width: 160,
    },
    {
      title: "Discount",
      key: "discount",
      dataIndex: "discount",
    },
    {
      title: "Tax",
      key: "tax_value",
      dataIndex: "tax_value",
      width: 120,
    },
    {
      title: "Tax Type",
      key: "tax_type",
      render: (data) => (
        <>
          {data?.tax_type == "igst" && "IGST"}
          {data?.tax_type == "cgst_sgst" && "CGST & SGST"}
          {data?.tax_type == "none" && "None"}
        </>
      ),
    },
  ];
  // const onSelectChangeSub = (selectedRowKeys, selectedRows) => {
  //   console.log(selectedRowsSub, "selectedRowKeys");
  //   var keys = selectedSubsKeys?.map((each) => each.id);
  //   for (var i = 0; i < selectedRowKeys?.length; i++) {}
  //   setSelectedRowKeysSub(...selectedRowKeysSub, selectedRowKeys);
  //   setSelectedRowsSub([...selectedRowsSub, selectedRows]);
  // };

  // const rowSelectionSub = {
  //   selectedRowKeysSub,
  //   onChange: onSelectChangeSub,
  // };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  // const handleSelectedSubs = (item, subItemsSelected) => {
  //   const itemKey = "item_" + item;
  //   var data = selectedSubs;
  //   if (data[itemKey]) {
  //     data[itemKey] = subItemsSelected;
  //   } else {
  //     data[itemKey] = subItemsSelected;
  //   }
  //   setSelectedSubs(data);
  // };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const changeSelections = () => {
    console.log("selectedRows", selectedRows, selectedSubs, selectedItems);
    let selectedRowsArr = [];
    for (let i = 0; i < selectedRows.length; i++) {
      var row = selectedRows[i];
      const index = selectedItems.findIndex((e) => e.id === row?.id);
      if (!row?.boq_sub_item && row?.sub_items && index > -1) {
        selectedRowsArr.push(selectedItems[index]);
      } else {
        if (row?.boq_sub_item) {
          let indexSub = selectedItems.findIndex((e) => e.id === row?.id);
          if (index > -1) {
            selectedRowsArr.push(selectedItems[indexSub]);
          } else {
            selectedRows[i]["discount"] = 0;
            selectedRows[i]["unit_po_price"] = selectedRows[i]["budget_price"];
            selectedRowsArr.push(row);
          }
        } else {
          selectedRows[i]["discount"] = 0;
          selectedRows[i]["unit_po_price"] = selectedRows[i]["budget_price"];
          selectedRowsArr.push(row);
        }
      }
    }

    var selectedSubItems = selectedSubs;
    for (var key in selectedSubItems) {
      if (selectedSubItems[key].length > 0) {
        var array = selectedSubItems[key];
        for (let i = 0; i < array.length; i++) {
          var row = array[i];
          const index = selectedItems.findIndex(
            (e) => e.boq_sub_item === row?.boq_sub_item
          );
          if (row?.boq_sub_item && index > -1) {
            selectedRowsArr.push(selectedItems[index]);
          } else {
            row["discount"] = 0;
            row["unit_po_price"] =
              selectedRows[i]["unit_po_price"] ?? row["budget_price"];
            selectedRowsArr.push(row);
          }
        }
      }
    }
    // for (let i = 0; i < selectedRowsSub.length; i++) {
    //   var row = selectedRowsSub[i];
    //   selectedRowsSub[i]["discount"] = 0;
    //   selectedRowsArr.push(row);
    // }
    setSelectedItems([...selectedRowsArr]);
    console.log(selectedRowsArr, "selected");
    props.setItems([...selectedRowsArr]);
    setVisible(false);
  };
  console.log(selectedRowKeys, "ss");

  useEffect(() => {
    console.log("ssssss");

    let sortedArray = items.sort((a, b) => {
      let x = selectedRowKeys.includes(a.id);
      let y = selectedRowKeys.includes(b.id);
      console.log("x", x, y, a.id);
      if (a.sub_items?.length) {
        a.sub_items.forEach((i) => {
          x = x | selectedRowKeys.includes(i.id);
        });
      }
      if (b.sub_items?.length) {
        b.sub_items.forEach((i) => {
          y = y | selectedRowKeys.includes(i.id);
        });
      }
      // console.log('WE ARE SORTING: ', a, b, x - y);
      return y - x;
    });
    setItems([...sortedArray]);
  }, [selectedItems, selectedRowKeys]);
  console.log(selectedItems, "selected");
  return (
    <React.Fragment>
      <div className="d-flex justify-content-end">
        <div className="ml-auto">
          {/* <div className="">Set default tax for all items</div>
          <div className="mt-2">
            <Col sm={24}>
              <Select
                className="w-100"
                onChange={(e) => {
                  onChangeDefaultTax(e);
                }}
              >
                <Option value={"none"} key={"none"}>
                  None
                </Option>
                {taxTypes?.map((each) => (
                  <Option key={each.id} value={each.id}>
                    {each.label}
                  </Option>
                ))}
              </Select>
            </Col>
          </div> */}
        </div>
      </div>
      <div className="my-2">
        <Table
          dataSource={selectedItems}
          columns={columns}
          pagination={false}
          scroll={{ x: "100%" }}
          rowKey={(data) => data.id}
        />
      </div>
      <div className="my-2">
        <Button
          type="dashed"
          onClick={() => setVisible(true)}
          className="w-100"
        >
          Add/Remove Item
        </Button>
      </div>
      <Modal
        title="Add/Remove Items"
        visible={visible}
        centered
        onOk={() => changeSelections()}
        onCancel={() => setVisible(false)}
        width="90vw"
        bodyStyle={{ height: "85vh", padding: 16 }}
      >
        <Row justify="end">
          <Search
            style={{
              width: "300px",
              marginBottom: 8,
            }}
            placeholder="Search items"
            onSearch={(value) => {
              setSearchText(value);
            }}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
          />
        </Row>
        <Table
          dataSource={items}
          columns={columnsModal}
          pagination={{
            position: ["bottomRight"],
          }}
          scroll={{
            x: "100%",
            y: window.innerHeight < 720 ? "62vh" : "62vh",
          }}
          rowKey={(data) => data.id}
          rowSelection={rowSelection}
          // expandable={{
          //   expandedRowRender: (data) => (
          //     <SubItemTable
          //       dataSource={data?.sub_items}
          //       itemId={data?.id}
          //       setSelectedSub={handleSelectedSubs}
          //       defaultSelected={selectedRowKeysSub}
          //       defaultSelectedSubs={selectedRowsSub}
          //     />
          //   ),
          //   rowExpandable: (data) => data?.sub_items.length > 0,
          // }}
        />
      </Modal>
    </React.Fragment>
  );
};

export default ItemTable;
